/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
import React, { useMemo } from 'react';
import * as ReactBootstrap from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { IReducer } from '../../../../redux/configureStore';
// import outstandingDebitsApp from '../../../../redux/duck/legado/outstandingDebitsApp';
import Wrapper from '../../../../shared/components/Wrapper';
import CardTotalDebits from './components/CardTotalDebits';
// import CardTotalDebits from './components/CardTotalDebits';
import Frame from './components/Frame';
import OutstandingDebitsFilter from './components/OutstandingDebitsFilter';
import OutstandingDebitsTableList from './components/OutstandingDebitsTableList';

function OutstandingDebits() {
  const outstandingDebitsListContext = useSelector(
    (reducer: IReducer) => reducer.outstandingDebitsApp
  );

  const loading = useMemo(() => {
    if (outstandingDebitsListContext.isLoading === true) {
      return (
        <Wrapper.Default margin="20% 0 0 0" isActive>
          <ReactBootstrap.Spinner animation="border" />
        </Wrapper.Default>
      );
    }
    return <></>;
  }, [outstandingDebitsListContext.isLoading]);

  const TableComponent = useMemo(() => {
    if (
      outstandingDebitsListContext.debits === undefined ||
      (outstandingDebitsListContext.debits.length === 0 &&
        outstandingDebitsListContext.gotSuccess)
    ) {
      Swal.fire('Não há clientes');
      return <></>;
    }
    if (outstandingDebitsListContext.isActive === false) {
      return <></>;
    }
    return (
      <>
        <CardTotalDebits />
        <OutstandingDebitsTableList />
      </>
    );
  }, [outstandingDebitsListContext.debits]);

  return (
    <Frame.Base>
      <OutstandingDebitsFilter />
      {loading}
      {TableComponent}
    </Frame.Base>
  );
}

export default OutstandingDebits;
